module.exports = __webpack_public_path__ + "img/usuario.65ca4151.png";